import { Box } from '@mui/material';
import LoadingPage from './LoadingPage';
import { isBootSplashActive } from '../../utils/bootSplash';

/**
 * Suspense / route fallback for store trees.
 * While the HTML boot splash is up, stay invisible so only one loader is seen.
 */
const StoreRouteFallback = ({ isShow = true }) => {
  if (isBootSplashActive()) {
    return <Box sx={{ minHeight: '100dvh', backgroundColor: 'transparent' }} />;
  }
  return <LoadingPage isShow={isShow} />;
};

export default StoreRouteFallback;
